import { render } from "./EditarPermissoes.vue?vue&type=template&id=7b41ed08"
import script from "./EditarPermissoes.vue?vue&type=script&lang=js"
export * from "./EditarPermissoes.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__